<template>
  <div class="flex flex-col gap-3"></div>
</template>

<script>
export default {
  name: 'DisplayOptionsContent',
  props: {
    displayOptions: {
      type: Object,
      required: true
    }
  },
  emits: ['update:displayOptions'],
  data() {
    return {
      localDisplayOptions: this.displayOptions
    }
  },
  watch: {
    localDisplayOptions: {
      handler(newValue) {
        this.$emit('update:displayOptions', newValue)
      },
      deep: true
    }
  }
}
</script>

<style scoped></style>
